import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { loaderItems } from "../../../../../../../shared/src/lib/utils/common";

@Component({
  selector: "app-sports-loader",
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./sports-loader.component.html",
  styleUrl: "./sports-loader.component.scss",
})
export class SportsLoaderComponent {
  @Input() show: boolean | null = false;
  protected readonly loaderItems = loaderItems;
}
